"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect, useRef } from "react";

const INDICATORS = [
  { feed: 12,   ticker: "USDSEK",   label: "USD/SEK" },
  { feed: 12,   ticker: "EURSEK",   label: "EUR/SEK" },
  { feed: 12,   ticker: "EURUSD",   label: "EUR/USD" },
  { feed: 2158, ticker: "BMUS-10Y", label: "USA 10 år" },
  { feed: 2158, ticker: "BMUS-2Y",  label: "USA 2 år" },
  { feed: 2158, ticker: "BMSE-2Y",  label: "Sverige 2 år" },
];

const ID = "indicator-row";

const IndicatorRow = () => {
  const { isReady, load } = useInfront();

  const widgetsRef = useRef<any[]>([]);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetsRef.current.forEach((w) => w.destroy());
      widgetsRef.current = [];

      function setupRowWithSingleValues(instrument: {
        feed: number;
        ticker: string;
      }) {
        const widgetOptions =
          new window.Infront.InstrumentSingleValueWidgetOptions();

        widgetOptions.name = "CHANGE";

        widgetOptions.rootElement = "span";
        widgetOptions.enableChangeStatusColors = true;
        widgetOptions.instrument = instrument;

        widgetsRef.current.push(
          window.infront.instrumentSingleValueWidget(
            `#${ID}-${instrument.ticker.replaceAll(" ", "-")}-change`,
            widgetOptions
          )
        );

        widgetOptions.name = "TIME";

        widgetsRef.current.push(
          window.infront.instrumentSingleValueWidget(
            `#${ID}-${instrument.ticker.replaceAll(" ", "-")}-time`,
            widgetOptions
          )
        );

        widgetOptions.name = "LAST";
        widgetOptions.enableChangeStatusColors = false;

        widgetsRef.current.push(
          window.infront.instrumentSingleValueWidget(
            `#${ID}-${instrument.ticker.replaceAll(" ", "-")}-last`,
            widgetOptions
          )
        );
      }

      INDICATORS.forEach((indicator) => {
        setupRowWithSingleValues(indicator);
      });
    });

    return () => {
      active = false;
      widgetsRef.current.forEach((w) => w.destroy());
      widgetsRef.current = [];
    };
  }, [isReady]);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
      {INDICATORS.map((indicator) => (
        <div key={indicator.ticker.replaceAll(" ", "_")} className="card">
          <div className="flex justify-between">
            <div className="text-sm">{indicator.label}</div>
            <div
              className="text-lg font-bold"
              id={`${ID}-${indicator.ticker.replaceAll(" ", "-")}-last`}
            />
          </div>

          <div className="flex justify-between">
            <div
              className="text-sm"
              id={`${ID}-${indicator.ticker.replaceAll(" ", "-")}-time`}
            />
            <div
              className="text-sm"
              id={`${ID}-${indicator.ticker.replaceAll(" ", "-")}-change`}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default IndicatorRow;
